import * as React from 'react';

/**
 * Renders a tab content, used by `<Tabs />`.
 */
export class Tab extends React.PureComponent {
    render() {
        const { children } = this.props;

        return <div className="custom-tabs__pane">{children}</div>;
    }
}
